// faq
function faq() {
  // otevření kategorie (tabu)
  $('.js-faq-open').on('click', function (event) {
    event.preventDefault();

    $('.faq__tab').hide();
    $('.js-faq-open').removeClass('is-open');
    $(this).addClass('is-open');

    // zjištění ID tabu z atributu rel
    let tabName = $(this).attr('href');

    // otevření tabu
    $(tabName).show(300);
  });

  // otevření konkrétního dotazu
  $('.faq__item h2').on('click', function () {
    $(this).closest('.faq__item').toggleClass('is-open');
  });

  //searching
  jQuery.expr[':'].icontains = function (a, i, m) {
    return jQuery(a).text().toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
  };

  $('#faq-input-search').keyup(function (event) {
    var value = $(this).val();
    if (value.length > 3) {
      $('.faq__item:not(:icontains("' + value + '"))').hide();
      $('.faq__item:icontains("' + value + '")')
        .addClass('faq-page--item--active')
        .show();
    } else {
      $('.faq__item').removeClass('faq-page--item--active').show();
    }
  });
}
